export default __webpack_public_path__ + "945817b.svg";